import { render } from "./SigninOrUpgrade.vue?vue&type=template&id=5e61524d"
import script from "./SigninOrUpgrade.vue?vue&type=script&lang=js"
export * from "./SigninOrUpgrade.vue?vue&type=script&lang=js"

import "./SigninOrUpgrade.vue?vue&type=style&index=0&id=5e61524d&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__